import React, { useState, useEffect, useContext } from "react";
import Moment from "moment";
import { Link } from "react-router-dom";
import Lottie from "react-lottie";
import { FiSearch, FiSend } from "react-icons/fi";
import axios from "axios";
import ReactSelect from "react-select";
import { toast } from "react-toastify";

import { Container, Content } from "./styles";

import api from "../../../services/api";

import VisaoGeral from "../../../components/VisaoGeralGerenciamento";

import SessionContext from "../../../contexts/sessionContext";

import { ProcessProps } from "../../../types/ProcessTypes";

import QuestionContext from "../../../contexts/QuestionContext";

import socket from "../../../services/socket";

import { customSelect } from "../../../misc/customStyle-ReactSelect";

import success from "../../../assets/animations/success.json";
import sending from "../../../assets/animations/sending.json";
import error from "../../../assets/animations/error.json";

function GerenciamentoProcessosAn() {
	const { setProcessId } = useContext(QuestionContext);
	const [process, setProcess] = useState<ProcessProps[]>([]);
	const [searchTerm, setSearchTerm] = useState("");

	const { user } = useContext(SessionContext);

	/*
		process:new -> Recebe o processo novo
		process:typist_one -> {id: id do processo, typist_one: dados do typist_one}
		process:typist_two -> {id: id do processo, typist_two: dados do typist_two}
		process:analist -> {id: id do processo, analist: dados do analista}
		process:status --> {id: id do processo, status: status do processo}
		process:document --> {id: id do processo, document: documento adicionado}
		process:typist_one_data --> {id: id do processo, infos: data do typist_one}
		process:typist_two_data --> {id: id do processo, infos_two: data do typist_two}
	*/
	useEffect(() => {
		const process_data = async () => {
			try {
				const { data } = await api.get("/data/process");

				if (data.data) setProcess(data.data);
			} catch (error) {
				return error;
			}
		};

		process_data();
	}, []);

	useEffect(() => {
		socket.on("process:remove", (id: number) => {
			setProcess((oldState) => {
				const newState = oldState?.filter(
					(process) => process.id !== Number(id),
				);

				return [...newState];
			});
		});

		socket.on("process:new", (data: any) => {
			setProcess((oldState) => [...oldState, data]);
		});

		socket.on(
			"process:new_value",
			({ id, process }: { id: number; process: ProcessProps }) => {
				setProcess((oldState) => {
					const newState = oldState?.map((current_process) => {
						console.log(process, id);
						console.log(current_process);

						if (current_process.id === id)
							current_process = process;

						return current_process;
					});

					return [...newState];
				});
			},
		);

		return () => {
			socket.removeListener("process:new");
			socket.removeListener("process:remove");
			socket.removeListener("process:new_value");
		};
	}, []);

	const handleAnalist = async (id: any) => {
		await api.patch(`/data/process&id=${id}/defineAnalist`, {
			user_id: user.id,
		});

		await api.patch(`/data/process&id=${id}/status`, {
			status: 2,
		});
	};

	const setSelectedProcess = (id: number) => {
		setProcessId(id);
		handleAnalist(id);
	};

	const ProcessComp = (process: ProcessProps) => {
		// COMPONENTE DO PROCESSO COM STATUS 0
		// STATUS 0 = AGUARDANDO ANÁLISE

		return (
			<tr className='process-comp'>
				<td id='prop-name' title={process.proponent_name}>
					{process.proponent_name}
				</td>
				<td>{process.cpf}</td>
				<td>{Moment(process.createdAt).format("DD/MM/YYYY")}</td>
				<td>{Moment(process.createdAt).format("HH:mm")}</td>
				<td>{process.typist_one?.name}</td>
				<td>{process.typist_two?.name}</td>
				<td>
					{process.analist == null ? (
						<Link to='/step-two'>
							<button
								type='button'
								onClick={() => setSelectedProcess(process.id)}
								className='get-in-form'>
								ENTRAR
							</button>
						</Link>
					) : (
						process.analist.name
					)}
				</td>
				<td>
					{process.status === 0
						? "Aguardando análise"
						: process.status === 1
						? "Pendente"
						: process.status === 2
						? "Em progresso"
						: process.status === 3
						? "Aprovado"
						: process.status === 4
						? "Reprovado"
						: process.status === 5
						? "Com divergência"
						: process.status === 6
						? "Aguardando digitador"
						: null}
				</td>
			</tr>
		);
	};

	const ProcessDig = (process: ProcessProps) => {
		// COMPONENTE PROCESSO COM STATUS 6
		// STATUS 6 = AGUARDANDO DIGITADOR

		return (
			<tr className='process-comp'>
				<td id='prop-name' title={process.proponent_name}>
					{process.proponent_name}
				</td>
				<td>{process.cpf}</td>
				<td>{Moment(process.createdAt).format("DD/MM/YYYY")}</td>
				<td>{Moment(process.createdAt).format("HH:mm")}</td>
				<td>
					{process.typist_one_id == null
						? "Vago"
						: process.typist_one.name}
				</td>
				<td>
					{process.typist_two_id == null
						? "Vago"
						: process.typist_two.name}
				</td>
				<td>
					<button className='buttons-ana' id='disabled'>
						INDISPONÍVEL
					</button>
				</td>
				<td style={{ color: "#3715ff", fontWeight: 600 }}>
					{process.status === 0
						? "Aguardando análise"
						: process.status === 1
						? "Pendente"
						: process.status === 2
						? "Em progresso"
						: process.status === 3
						? "Aprovado"
						: process.status === 4
						? "Reprovado"
						: process.status === 5
						? "Com divergência"
						: process.status === 6
						? "Aguardando digitador"
						: null}
				</td>
			</tr>
		);
	};

	const ProcessError = (process: ProcessProps) => {
		// COMPONENTE DO PROCESSO COM STATUS 5
		// STATUS 5 = COM DIVERGÊNCIA

		return (
			<tr className='process-comp'>
				<td id='prop-name' title={process.proponent_name}>
					{process.proponent_name}
				</td>
				<td>{process.cpf}</td>
				<td>{Moment(process.createdAt).format("DD/MM/YYYY")}</td>
				<td>{Moment(process.createdAt).format("HH:mm")}</td>
				<td>{process.typist_one.name}</td>
				<td>{process.typist_two.name}</td>
				<td>
					<Link to={`/processo-com-erro&id=${process.id}`}>
						<button className='buttons-ana' id='edit'>
							CORRIGIR
						</button>
					</Link>
				</td>
				<td style={{ color: "#E8652C", fontWeight: 600 }}>
					{process.status === 0
						? "Aguardando análise"
						: process.status === 1
						? "Pendente"
						: process.status === 2
						? "Em progresso"
						: process.status === 3
						? "Aprovado"
						: process.status === 4
						? "Reprovado"
						: process.status === 5
						? "Com divergência"
						: process.status === 6
						? "Aguardando digitador"
						: null}
				</td>
			</tr>
		);
	};

	const ProcessFinalStatus = (process: ProcessProps) => {
		// COMPONENTE DO PROCESSO COM STATUS 7
		// STATUS 7 = Finalizado

		return (
			<tr className='process-comp'>
				<td id='prop-name' title={process.proponent_name}>
					{process.proponent_name}
				</td>
				<td>{process.cpf}</td>
				<td>{Moment(process.createdAt).format("DD/MM/YYYY")}</td>
				<td>{Moment(process.createdAt).format("HH:mm")}</td>
				<td>{process.typist_one?.name}</td>
				<td>{process.typist_two?.name}</td>
				<td>{process.analist?.name}</td>
				<td style={{ color: "#2bde53", fontWeight: 600 }}>
					{process.status === 0
						? "Aguardando análise"
						: process.status === 1
						? "Pendente"
						: process.status === 2
						? "Em progresso"
						: process.status === 3
						? "Aprovado"
						: process.status === 4
						? "Reprovado"
						: process.status === 5
						? "Com divergência"
						: process.status === 6
						? "Aguardando digitador"
						: process.status === 7
						? "Finalizado"
						: null}
				</td>
			</tr>
		);
	};

	const ProcessApprovedStatus = ({ process }: { process: any }) => {
		// COMPONENTE DO PROCESSO COM STATUS 3
		// STATUS 3 = Aprovado
		const [isFinishingProcess, setIsFinishingProcess] = useState(false);
		const [finishingCode, setFinishingCode] = useState("");
		const [caixaUser, setCaixaUser] = useState("");
		const [password, setPassword] = useState("");

		const handleRegisterStep = () => {
			let status;

			const defaultOptions = {
				loop: false,
				autoplay: true,
				renderSettings: {
					preserveAspectRatio: "xMidYMid slice",
				},
			};

			// Define icone referente ao status na caixa
			switch (process.register_step) {
				case 0:
					status = (
						<button
							className='send-icon'
							onClick={() => setIsFinishingProcess(true)}>
							<FiSend size={20} color='#2d7bbc' />
						</button>
					);
					break;
				case 2:
					status = (
						<Lottie
							width={30}
							height={30}
							options={{
								...defaultOptions,
								animationData: success,
							}}
						/>
					);
					break;
				case 3:
					status = (
						<Lottie
							width={23}
							height={23}
							options={{
								...defaultOptions,
								animationData: error,
							}}
							title={process.register_error}
						/>
					);
					break;
				default:
					status = (
						<Lottie
							width={60}
							height={60}
							options={{
								...defaultOptions,
								animationData: sending,
								loop: true,
							}}
						/>
					);
					break;
			}

			// Retorna icone
			return status;
		};

		const handleFinishProcess = async () => {
			let processData: any = {};

			if (process.correct_infos)
				Object.keys(process.infos).map((typist: any) => {
					Object.keys(process.correct_infos).map(
						(rightAnswer: any) => {
							process.infos[typist] ===
							process.correct_infos[rightAnswer]
								? (processData[typist] = process.infos[typist])
								: (processData[rightAnswer] =
										process.correct_infos[rightAnswer]);
						},
					);
				});
			else processData = process.infos;

			axios
				.post("https://envio-caixa-topaz.vercel.app/api/process-form", {
					// .post("http://localhost:3001/api/process-form", {
					id: process.id,
					cod: finishingCode,
					login: caixaUser,
					password,
					...processData,
				})
				.catch((error) => {
					console.log(error);

					toast.error("Erro ao cadastrar o processo!", {
						position: toast.POSITION.TOP_RIGHT,
					});
				});

			toast.success("Processo enviado para cadastro na caixa!", {
				position: toast.POSITION.TOP_RIGHT,
			});

			setIsFinishingProcess(false);
			setFinishingCode("");
		};

		return (
			<>
				{isFinishingProcess ? (
					<>
						<div
							className='popup-shadow'
							onClick={() => {
								setIsFinishingProcess(false);
								setFinishingCode("");
							}}></div>
						<div className='popup-finishing-process'>
							<label>
								Código de envio caixa
								<ReactSelect
									options={[
										{
											value: "000465240",
											label: "000465240",
										},
										{
											value: "000577340",
											label: "000577340",
										},
										{
											value: "000718980",
											label: "000718980",
										},
										{
											value: "000489573",
											label: "000489573",
										},
									]}
									onChange={(val) => {
										console.log("val", val);
										setFinishingCode(
											val?.value ? val.value : "",
										);
									}}
									placeholder='Selecione um código'
									name='finishing_code'
									styles={customSelect}
								/>
							</label>
							<div className='input-div'>
								<p className='input-title'>Usuário</p>
								<input
									className='input-content'
									name='user'
									type='text'
									value={caixaUser}
									onChange={(e) => {
										setCaixaUser(e.target.value);
									}}
								/>
							</div>
							<div className='input-div'>
								<p className='input-title'>Senha</p>
								<input
									className='input-content'
									name='password'
									value={password}
									type='password'
									onChange={(e) => {
										setPassword(e.target.value);
									}}
								/>
							</div>
							<div className='send-container'>
								<button
									disabled={
										finishingCode === "" ||
										finishingCode === undefined
									}
									onClick={() => handleFinishProcess()}
									className='send-caixa'>
									Enviar para caixa
								</button>
							</div>
						</div>
					</>
				) : (
					""
				)}
				<tr className='process-comp'>
					<td id='prop-name' title={process.proponent_name}>
						{process.proponent_name}
					</td>
					<td>{process.cpf}</td>
					<td>{Moment(process.createdAt).format("DD/MM/YYYY")}</td>
					<td>{Moment(process.createdAt).format("HH:mm")}</td>
					<td>{process.typist_one.name}</td>
					<td>{process.typist_two.name}</td>
					<td>
						<button
							type='button'
							className='buttons-ana'
							id='final'
							onClick={() => {
								setIsFinishingProcess(true);
							}}>
							Enviar
						</button>
					</td>
					<td style={{ color: "#2d7bbc", fontWeight: 600 }}>
						{process.status === 0
							? "Aguardando análise"
							: process.status === 1
							? "Pendente"
							: process.status === 2
							? "Em progresso"
							: process.status === 3
							? "Aprovado"
							: process.status === 4
							? "Reprovado"
							: process.status === 5
							? "Com divergência"
							: process.status === 6
							? "Aguardando digitador"
							: null}
					</td>
					<td>{process && handleRegisterStep()}</td>
				</tr>
			</>
		);
	};

	return (
		<Container>
			<Content>
				<div className='header'>
					<div className='func-name'>
						<p id='func'>Analista</p>
						<p id='name'>{user.name}</p>
					</div>

					<div className='Search-container'>
						<FiSearch />
						<input
							type='text'
							id='searchBox'
							placeholder='Buscar por nome ou cpf...'
							onChange={(e) => setSearchTerm(e.target.value)}
						/>
					</div>

					<VisaoGeral />
				</div>

				<div className='process-manager'>
					<div className='ana-table'>
						<p id='keep-title'>Aguardando Análise</p>
						<div className='table-container'>
							<div className='table-wrapper'>
								<table className='table-wrapper'>
									<tr>
										<th>Nome do Proponente</th>
										<th>CPF</th>
										<th>Data</th>
										<th>Hora</th>
										<th>Digitador 1</th>
										<th>Digitador 2</th>
										<th>Analista</th>
										<th>Status</th>
									</tr>

									{process ? (
										process
											.filter((item) => {
												if (searchTerm === "") {
													return item;
												} else if (
													item.proponent_name
														.toLowerCase()
														.includes(
															searchTerm.toLowerCase(),
														)
												) {
													return item;
												} else if (
													item.cpf.includes(
														searchTerm,
													)
												) {
													return item;
												}
											})
											.filter((item) => {
												if (item.status === 0) {
													return item;
												}
											})
											.map((i) => {
												return (
													<ProcessComp
														proponent_name={
															i.proponent_name
														}
														id={i.id}
														cpf={i.cpf}
														createdAt={i.createdAt}
														analist={i.analist}
														status={i.status}
														typist_one={
															i.typist_one
														}
														typist_one_id={
															i.typist_one_id
														}
														typist_two={
															i.typist_two
														}
														typist_two_id={
															i.typist_two_id
														}
														key={i.id}
													/>
												);
											})
									) : (
										<div></div>
									)}
								</table>
							</div>
						</div>
					</div>

					<div className='error-table'>
						<p id='ErrorProcess-title'>Erro de Divergência</p>

						<div className='table-container'>
							<div className='table-wrapper'>
								<table className='table-wrapper'>
									<tr>
										<th>Nome do Proponente</th>
										<th>CPF</th>
										<th>Data</th>
										<th>Hora</th>
										<th>Digitador 1</th>
										<th>Digitador 2</th>
										<th>Analista</th>
										<th>Status</th>
									</tr>

									{process ? (
										process
											.filter((item) => {
												if (searchTerm === "") {
													return item;
												} else if (
													item.proponent_name
														.toLowerCase()
														.includes(
															searchTerm.toLowerCase(),
														)
												) {
													return item;
												} else if (
													item.cpf.includes(
														searchTerm,
													)
												) {
													return item;
												}
											})
											.filter((item) => {
												if (item.status === 5) {
													return item;
												}
											})
											.map((i) => {
												return (
													<ProcessError
														proponent_name={
															i.proponent_name
														}
														id={i.id}
														cpf={i.cpf}
														createdAt={i.createdAt}
														analist={i.analist}
														status={i.status}
														typist_one={
															i.typist_one
														}
														typist_one_id={
															i.typist_one_id
														}
														typist_two={
															i.typist_two
														}
														typist_two_id={
															i.typist_two_id
														}
														key={i.id}
													/>
												);
											})
									) : (
										<div></div>
									)}
								</table>
							</div>
						</div>
					</div>

					<div className='final-table'>
						<p id='ApprovedProcess-title'>Enviar</p>
						<div className='table-container'>
							<div className='table-wrapper'>
								<table className='table-wrapper'>
									<tr>
										<th>Nome do Proponente</th>
										<th>CPF</th>
										<th>Data</th>
										<th>Hora</th>
										<th>Digitador 1</th>
										<th>Digitador 2</th>
										<th>Analista</th>
										<th>Status</th>
										<th>Status na caixa</th>
									</tr>

									{process ? (
										process
											.filter((item) => {
												if (searchTerm === "") {
													return item;
												} else if (
													item.proponent_name
														.toLowerCase()
														.includes(
															searchTerm.toLowerCase(),
														)
												) {
													return item;
												} else if (
													item.cpf.includes(
														searchTerm,
													)
												) {
													return item;
												}
											})
											.filter((item) => {
												if (item.status === 3) {
													return item;
												}
											})
											.map((i: any) => {
												return (
													<ProcessApprovedStatus
														process={i}
													/>
												);
											})
									) : (
										<div></div>
									)}
								</table>
							</div>
						</div>
					</div>

					<div className='final-table'>
						<p id='FinalProcess-title'>Finalizados</p>
						<div className='table-container'>
							<div className='table-wrapper'>
								<table className='table-wrapper'>
									<tr>
										<th>Nome do Proponente</th>
										<th>CPF</th>
										<th>Data</th>
										<th>Hora</th>
										<th>Digitador 1</th>
										<th>Digitador 2</th>
										<th>Analista</th>
										<th>Status</th>
									</tr>

									{process ? (
										process
											.filter((item) => {
												if (searchTerm === "") {
													return item;
												} else if (
													item.proponent_name
														.toLowerCase()
														.includes(
															searchTerm.toLowerCase(),
														)
												) {
													return item;
												} else if (
													item.cpf.includes(
														searchTerm,
													)
												) {
													return item;
												}
											})
											.filter((item) => {
												if (item.status === 7) {
													return item;
												}
											})
											.map((i: any) => {
												return (
													<ProcessFinalStatus
														proponent_name={
															i.proponent_name
														}
														id={i.id}
														cpf={i.cpf}
														createdAt={i.createdAt}
														analist={i.analist}
														status={i.status}
														typist_one={
															i.typist_one
														}
														typist_one_id={
															i.typist_one_id
														}
														typist_two={
															i.typist_two
														}
														typist_two_id={
															i.typist_two_id
														}
														key={i.id}
														typist_one_data={
															i.infos
														}
														typist_two_data={
															i.infos_two
														}
														correct_infos={
															i.correct_infos
														}
													/>
												);
											})
									) : (
										<div></div>
									)}
								</table>
							</div>
						</div>
					</div>

					<div className='pending-table'>
						<p id='PendingProcess-title'>Aguardando Digitadores</p>
						<div className='table-container'>
							<div className='table-wrapper'>
								<table className='table-wrapper'>
									<tr>
										<th>Nome do Proponente</th>
										<th>CPF</th>
										<th>Data</th>
										<th>Hora</th>
										<th>Digitador 1</th>
										<th>Digitador 2</th>
										<th>Analista</th>
										<th>Status</th>
									</tr>

									{process ? (
										process
											.filter((item) => {
												if (searchTerm === "") {
													return item;
												} else if (
													item.proponent_name
														.toLowerCase()
														.includes(
															searchTerm.toLowerCase(),
														)
												) {
													return item;
												} else if (
													item.cpf.includes(
														searchTerm,
													)
												) {
													return item;
												}
											})
											.filter((item) => {
												if (item.status === 6) {
													return item;
												}
											})
											.map((i) => {
												return (
													<ProcessDig
														proponent_name={
															i.proponent_name
														}
														id={i.id}
														cpf={i.cpf}
														createdAt={i.createdAt}
														analist={i.analist}
														status={i.status}
														typist_one={
															i.typist_one
														}
														typist_one_id={
															i.typist_one_id
														}
														typist_two={
															i.typist_two
														}
														typist_two_id={
															i.typist_two_id
														}
														key={i.id}
													/>
												);
											})
									) : (
										<div></div>
									)}
								</table>
							</div>
						</div>
					</div>
				</div>
			</Content>
		</Container>
	);
}

export default GerenciamentoProcessosAn;
